import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import { IAdultsInCharge } from 'src/app/core/models/infant-reassignment-control.model';
import { infantControlActions } from '../actions';
import { getAdultsIncharge } from '../selectors/infant-control.selectors';

@Injectable({
  providedIn: 'root'
})
export class InfantControlService {
  constructor(private store: Store<State>) {}

  dispatchSetInfantReassignmentControl({
    adultsInCharge,
    infantID
  }: {
    adultsInCharge: IAdultsInCharge;
    infantID: string;
  }) {
    return this.store.dispatch(
      infantControlActions.SetInfantReassignmentControl({ adultsInCharge, infantID })
    );
  }

  clearInfantReassignmentControl(adultsInCharge: IAdultsInCharge, infantID: string) {
    return this.store.dispatch(
      infantControlActions.ClearInfantReassignmentControl({ adultsInCharge, infantID })
    );
  }

  getAdultsIncharge(): Observable<IAdultsInCharge[]> {
    return this.store.pipe(select(getAdultsIncharge));
  }
}
